
import React, { useMemo } from 'react';
import type { GridRow, GridColumn } from '../types/gridTypes';
import { computeSummary } from '../utils/summary';

interface Props {
  rows: GridRow[];
  columns: GridColumn[];
}

export const SidebarSummary: React.FC<Props> = ({ rows, columns }) => {
  const summary = useMemo(() => computeSummary(columns, rows), [columns, rows]);
  const summaryCount = Object.keys(summary).length;

  return (
    <div className="sidebar-panel flex flex-col gap-4 p-4 overflow-y-auto h-full flex-1">
      <div className="sidebar-section-title text-xs font-bold uppercase tracking-wide">Sheet Summary</div>

      {summaryCount === 0 && (
         <div className="sidebar-empty-state text-sm italic p-4 border border-dashed rounded text-center">
             No summary columns configured.<br/>
             <span className="text-xs">Set 'summaryMode' on columns to see metrics here.</span>
         </div>
      )}

      <div className="grid grid-cols-1 gap-3">
        {Object.entries(summary).map(([colId, data]) => {
            const col = columns.find(c => c.id === colId);
            return (
                <div key={colId} className="sidebar-summary-card p-4 rounded-lg border shadow-sm flex flex-col gap-1">
                    <div className="flex justify-between items-start">
                        <div className="sidebar-summary-label text-sm font-medium">{col?.label}</div>
                        <div className="sidebar-summary-badge text-[10px] font-bold px-2 py-0.5 rounded uppercase tracking-wider">
                            {data.label}
                        </div>
                    </div>
                    <div className="sidebar-summary-value text-2xl font-bold tracking-tight mt-1">{data.value}</div>
                </div>
            );
        })}
      </div>
    </div>
  );
};
